import { render, staticRenderFns } from "./DroughtDamages.vue?vue&type=template&id=2beb7dc5"
import script from "./DroughtDamages.vue?vue&type=script&lang=ts"
export * from "./DroughtDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports